<template>
    <div class='landing_page'>
        <div class='main_picture'>
          <!--<img src='/moving.gif' alt='Chet Enright Logo' />-->
          <LazyPhoto src="/moving.gif" loading_photo="/still.png" />
          <h1>CHESTER ENRIGHT</h1>
        
        </div>

        <div class="landing_nav_div sections">
            <div v-for="data in json.sections" v-bind:key="data.scrollTo">
            <a :href="data.scrollTo" v-if="data.external">

                <img class="grey" v-bind:src="data.src" height="40px" v-bind:alt="data.title" />
                <br>{{data.title}}
            </a>
            <a href="#" v-scroll-to="'' + data.scrollTo" v-else>

                <img class="grey" v-bind:src="data.src" height="40px" v-bind:alt="data.title" />
                <br>{{data.title}}
            </a>

            </div> 
            
        </div>
    </div>
</template>

<script>
    import json from '../../data/nav.json'
    import LazyPhoto from "@/components/LazyPhotos"
    export default {
        Name: "Header",
        components: {
          LazyPhoto
        },
        props: [],
        methods: {

        },
        data() {
            return {
                json: json
            }

        }
    }
</script>

<style lang="scss">
    /* Modern landing page */
    h1{
      font-weight: 700;
      letter-spacing: 0px;
      border-bottom: none;
      padding-bottom: 30px;
      width: auto;
      min-width: 300px;
      margin: 0 auto 50px;
      font-size: 3.5rem;
      color: #2c3e50;
    }
    
    div.landing_page {
        text-align: center;
        margin: auto;
        min-height: 100vh;
        background-color: $bg-nav;
        padding: 60px 20px;
        display: flex;
        flex-direction: column;
        justify-content: center;
    }

    div.landing_page div.main_picture {
        width: 100%;
        clear: both;
        margin: 0 auto 40px;
    }

    div.landing_page div.main_picture img {
        width: 280px;
        max-width: 90%;
        height: auto;
        margin: 0 auto;
        transition: transform 0.3s ease;
    }
    
    div.landing_page div.main_picture img:hover {
        transform: scale(1.05);
    }

    @media screen and (max-width: 760px) {
        div.landing_page div.main_picture img {
            width: 50%;
        }
        h1 {
            font-size: 2rem;
        }
    }

    @media screen and (min-width: 1500px) {
        div.landing_page div.main_picture img {
            width: 20%;
            margin-bottom: 40px;
        }
    }

    div.landing_page div.landing_nav_div {
        width: 90%;
        max-width: 900px;
        margin: 0 auto;
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        gap: 20px;
        padding: 20px 0;
    }

    div.landing_nav_div div {
        margin: 0;
        padding: 15px 20px 20px 15px;
        text-align: center;
        background: $bg-white;
        border-radius: $border-radius-sm;
        box-shadow: $shadow-sm;
        transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        min-width: 0;
    }
    
    div.landing_nav_div div:hover {
        transform: translateY(-6px);
        box-shadow: $shadow-lg;
    }

    @media screen and (max-width: 760px) {
        div.landing_page {
            padding: 40px 15px;
        }
        div.landing_nav_div {
            grid-template-columns: repeat(2, 1fr);
            gap: 16px;
            max-width: 400px;
        }
        div.landing_nav_div div {
            padding: 24px 16px;
        }
        h1 {
            font-size: 2.25rem;
        }
    }

    div.landing_nav_div div img {
        cursor: pointer;
        transition: all 0.3s ease;
        filter: none;
        -webkit-filter: none;
        margin-bottom: 12px;
        width: 40px;
        height: 40px;
    }

    div.landing_nav_div div:hover img{
        transform: scale(1.15);
    }

    div.landing_nav_div a {
        font-size: 14px;
        font-weight: 600;
        font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
        text-decoration: none;
        color: $text-medium;
        transition: color 0.2s ease;
        letter-spacing: 0.75px;
        display: block;
    }

    div.landing_nav_div a:hover {
        text-decoration: none;
        color: $primary;
    }

    div.landing_nav_div a:visited {
        text-decoration: none;
        color: $text-dark;
    }
</style>
